import React from "react";
import { ImagesCarouselBlade, IImagesCarouselSlide } from "@organic-return/foundation-react/src/components/Blades/ImagesCarouselBlade"
import { graphql } from "gatsby";


const ImagesCarousel = (props: any) => {

    const slides = props.slides?.map((s: any): IImagesCarouselSlide => {
        return {
            image: { url: s.image.url },
            title: s.title,
            titlePosition: {
                horizontal: s.titleHorizontalPosition,
                vertical: s.titleVerticalPosition
            }
        }
    }) ?? []

    return (
        <section className={`w-full h-screen images-carousel-module`}>
            <ImagesCarouselBlade
                slides={slides}
                sliderSettings={{
                    fade: true,
                }}
            />
        </section>
    )
}

export default ImagesCarousel

export const query = graphql`
fragment DrupalImagesCarouselContent on DrupalImagesCarousel {
    id
    slides {
        image {
            url
        }
        subtitle
        title
        titleHorizontalPosition
        titleVerticalPosition
    }
}
`